import {
  Row,
  Col,
  Typography,
  Button,
  Form,
  Input,
  Tooltip,
  Checkbox,
  Select,
  Image,
  Space,
  List,
  Popover,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Field, FieldProps, Formik } from "formik";
import { OnBoarding } from "@components/index";
import { Icon } from "@iconify/react";
import { omit } from "lodash";
import { post } from "@services/api.service";
import { useNotification } from "~/Hooks/useNotification";
import { CountryCode, parsePhoneNumber } from "libphonenumber-js";
import "yup-phone";
import { useState } from "react";
import * as yup from "yup";
import { NumberInput } from "@components/index";
import logo from "@assets/SVG/logo.svg";

import styles from "../Auth.module.scss";

const phoneSchema = yup.string().phone().required();

const { Option } = Select;
const { Title, Text } = Typography;

export const SignUp = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { openToast, openNotification } = useNotification();

  return (
    <OnBoarding>
      <Row className="sign-up">
        <Col span={18} offset={3}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              flexDirection: "column",
              justifyContent: "center",
              marginBottom: styles.whitespace2,
            }}
          >
            <Image
              src={logo}
              preview={false}
              style={{
                maxWidth: 120,
                cursor: "pointer",
              }}
            />
            <Title
              level={2}
              style={{
                textAlign: "center",
                marginTop: 10,
                marginBottom: 10,
                color: "#0C233C",
              }}
            >
              Create an Account
            </Title>

            <Text className="textSmall" style={{ textAlign: "center" }}>
              Follow the instructions to make it easier to register and you will
              be able to explore inside.
            </Text>
          </div>

          <Col span={24} style={{ marginTop: 10 }}>
            <Formik
              initialValues={{
                emailAddress: "",
                designation: "",
                accept: false,
                password: "",
                confirmPassword: "",
              }}
              validationSchema={yup.object().shape({
                emailAddress: yup
                  .string()
                  .email("Please enter valid email address")
                  .required("Email address required"),
                designation: yup.string().required("Designation required"),
                password: yup
                  .string()
                  .matches(
                    new RegExp(
                      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
                    ),
                    "Password dosen't meet the requirements"
                  )
                  .required("Password required")
                  .min(8),
                accept: yup
                  .bool() // use bool instead of boolean
                  .oneOf([true], "You must accept the terms and conditions"),
              })}
              onSubmit={(values, { setFieldError }) => {
                localStorage.setItem("role", values.designation);
                navigate("/dashboard");
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                setFieldValue,
                handleSubmit,
                handleBlur,
                isValid,
              }) => {
                return (
                  <Form layout="vertical" onFinish={handleSubmit}>
                    <Form.Item style={{ marginBottom: 20 }}>
                      <Input
                        name="emailAddress"
                        type={"email"}
                        size="large"
                        value={values.emailAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Email"
                        className={
                          errors.emailAddress && touched.emailAddress
                            ? styles.inputErrorFiled
                            : ""
                        }
                      />
                      {errors.emailAddress && touched.emailAddress && (
                        <Text type="danger">{errors.emailAddress}</Text>
                      )}
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 20 }}>
                      <Select
                        onChange={(value) =>
                          setFieldValue("designation", value)
                        }
                        onBlur={handleBlur}
                        value={values.designation}
                        size="large"
                        placeholder="Designation"
                        showSearch
                        className={
                          errors.designation && touched.designation
                            ? styles.inputErrorFiled
                            : ""
                        }
                      >
                        <Option value="" selected>
                          --Select--
                        </Option>
                        {[
                          {
                            id: "investor",
                            value: "I am an Investor",
                          },
                          {
                            id: "developer",
                            value: "Project Developer",
                          },
                        ].map((item, i) => (
                          <Option value={item.id} key={`${item}-${i}`}>
                            {item.value}
                          </Option>
                        ))}
                      </Select>
                      {errors.designation && touched.designation && (
                        <Text type="danger">{errors.designation}</Text>
                      )}
                    </Form.Item>
                    <Form.Item
                      style={{ marginBottom: 20 }}
                      tooltip={{
                        placement: "right",
                        color: "#fff",
                        icon: <Icon icon="bi:info-circle-fill" color="gray" />,
                        overlayInnerStyle: {
                          width: 300,
                        },
                      }}
                    >
                      <Input.Password
                        name="password"
                        autoComplete="new-password"
                        size="large"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Password"
                        minLength={8}
                        iconRender={(visible) =>
                          visible ? (
                            <Icon
                              icon="akar-icons:eye-open"
                              style={{ cursor: "pointer", color: styles.gray }}
                            />
                          ) : (
                            <Icon
                              icon="akar-icons:eye-closed"
                              style={{ cursor: "pointer", color: styles.gray }}
                            />
                          )
                        }
                        className={
                          errors.password && touched.password
                            ? styles.inputErrorFiled
                            : ""
                        }
                      />
                      {errors.password && touched.password && (
                        <Text type="danger">{errors.password}</Text>
                      )}
                    </Form.Item>
                    <Form.Item
                      tooltip={{
                        placement: "right",
                        color: "#fff",
                        icon: <Icon icon="bi:info-circle-fill" color="gray" />,
                        overlayInnerStyle: {
                          width: 300,
                        },
                      }}
                    >
                      <Input.Password
                        name="confirmPassword"
                        autoComplete="new-password"
                        size="large"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        minLength={8}
                        placeholder="Confirm Password"
                        iconRender={(visible) =>
                          visible ? (
                            <Icon
                              icon="akar-icons:eye-open"
                              style={{ cursor: "pointer", color: styles.gray }}
                            />
                          ) : (
                            <Icon
                              icon="akar-icons:eye-closed"
                              style={{ cursor: "pointer", color: styles.gray }}
                            />
                          )
                        }
                        className={
                          errors.confirmPassword && touched.confirmPassword
                            ? styles.inputErrorFiled
                            : ""
                        }
                      />
                      {errors.confirmPassword && touched.confirmPassword && (
                        <Text type="danger">{errors.confirmPassword}</Text>
                      )}
                    </Form.Item>
                    <Form.Item>
                      <Space>
                        <Checkbox
                          name="accept"
                          checked={values.accept}
                          value={values.accept}
                          onChange={handleChange}
                        />
                        I accept
                        <Link className={styles.loginFormForgot} to="">
                          Terms &amp; Conditions
                        </Link>
                      </Space>
                      <div>
                        {errors.accept && touched.accept && (
                          <Text type="danger">{errors.accept}</Text>
                        )}
                      </div>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className={styles.loginButton}
                        size="large"
                        block
                        // disabled={
                        //   !isValid ||
                        //   (Object.keys(touched).length === 0 &&
                        //     touched.constructor === Object)
                        // }
                        loading={isLoading}
                      >
                        Create Account
                      </Button>
                    </Form.Item>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Row>
            <Col span={24} style={{ marginTop: 20, textAlign: "center" }}>
              <Space>
                <Typography.Text className={styles.loginDontText}>
                  Already have an account?
                </Typography.Text>
                <Link to="/auth/login" style={{ fontWeight: "bold" }}>
                  Sign In{" "}
                </Link>
              </Space>
            </Col>
          </Row>
          <Button
            htmlType="submit"
            // className={styles.loginButton}
            size="large"
            block
            style={{ marginTop: 10 }}
            loading={isLoading}
          >
            <Space
              size={"middle"}
              style={{
                display: "flex",
                verticalAlign: "middle",
                alignItems: "center",
              }}
            >
              <Icon
                icon={"logos:google-icon"}
                style={{ verticalAlign: "middle" }}
              ></Icon>
              <Typography.Text>Google</Typography.Text>
            </Space>
          </Button>
        </Col>
      </Row>
    </OnBoarding>
  );
};
